export default {
  // Page Register --------------------------
  summary: [],
  pageRegister: null,
  customers: null,
  salesManagers: null,
  bidNumber: null,
  customer: null,
  // Bid Decision --------------------------
  bidDecision: null,
  bidDecisionCriteriaSets: null,
  bidDecisionSettings: {
    strategic: [],
    client: [],
    capability: [],
    estimatedFee: [],
    location: [],
    delivery: [],
  },
  decisionSet: {},
  // Google --------------------------
  coordinates: {},
  centerCoordinates: {
    lat: 51.5,
    lng: -0.2,
  },
  geocode: [],
  authority: {},
  roadspeed: {},
  // Specifications --------------------------
  specifications: {},
  siteItem: {},
  arms: [],
  cpTypeArmCount: null,
  kitType: null,
  mapSettings: {
    zoom: 20,
  },
}
